import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, companyRequestsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, companyRequestsActions);

export default slice.reducer;
